export default "__VITE_ASSET__DtP5Nezh__"